<div [class]="'share ' + projectType">
	<div class="share-content">
		<div class="row columns">
			<p class="teaser" >{{ teaserTextkey | translate }}</p>
			<p class="icons">
				<a href="https://api.whatsapp.com/send?text={{ 'share.whatsapp.text' | translate | encodeURI }}%20{{ getEncodedUrl(url) }}" target="_blank" class="whatsapp" title="{{ 'share.whatsapp.title' | translate }}"><i class="twingle-whatsapp"></i></a>
				<a href="https://www.facebook.com/sharer/sharer.php?u={{ getEncodedUrl(url) }}" (click)="openPopup($event, 'https://www.facebook.com/sharer/sharer.php?u=' + getEncodedUrl(url))" class="facebook" title="{{ 'share.facebook.title' | translate }}"><i class="twingle-facebook2"></i></a>
				<a href="mailto:?subject={{ 'share.mail.subject' | translate | encodeURI }}&amp;body={{ 'share.mail.body' | translate | encodeURI }}{{ getEncodedUrl(url) }}" class="mail" title="{{ 'share.mail.title' | translate }}"><i class="twingle-letter_light"></i></a>
			</p>
		</div>
	</div>
</div>
